export * from './api-urls';
export * from './query-keys';

export type mockDataProps = {
  product: string;
  description: string;
  price: number;
  users: number;
  total: number;
};

export const mockData: mockDataProps[] = [
  {
    product: 'CORE - ENTERPRISE',
    description: 'Your next-level practice in a Box',
    price: 79.5,
    users: 16,
    total: 1272,
  },
  {
    product: 'PROGRESS - LITE',
    description: 'Less time spent, more impact on clients',
    price: 335,
    users: 15,
    total: 335,
  },
  {
    product: 'ENGAGE - LITE',
    description: 'Start clients right, with engage',
    price: 115,
    users: 3,
    total: 115,
  },
  {
    product: 'PROTECT - PRO',
    description: 'Start clients right, with basic',
    price: 500,
    users: 10,
    total: 500,
  },
];

export const productTag: string[] = [
  'Your next-level practice in a Box',
  'Less time spent, more impact on clients',
  'Tax Advisory as a business, not a chore',
  'Start clients right, with engage',
  'Start clients right, with basic',
];
